import { FormikProps } from 'formik';
import React from 'react';
import { DesignFormModel } from '../../designs/design-form/designFormModel';
import { BuildTypeCode } from '../../projects/project';
import { QuoteFormModel } from '../../quotes/quote-form/quoteFormModel';
import { DataForQuoteOrDesignForm } from './GetDataForQuoteOrDesignForm';

type SharedProps = {
  buildTypeCode: BuildTypeCode;
  externalAirTemperatureInDegreesCelsius: number;
  referenceData: DataForQuoteOrDesignForm;
};

type QuoteFormContextValue = SharedProps & {
  formType: 'Quote';
  formProps: FormikProps<QuoteFormModel>;
};

type DesignFormContextValue = SharedProps & {
  formType: 'Design';
  formProps: FormikProps<DesignFormModel>;
};

export type QuoteOrDesignFormContextValue = QuoteFormContextValue | DesignFormContextValue;

export const QuoteOrDesignFormContext = React.createContext<QuoteOrDesignFormContextValue | undefined>(undefined);

export const isQuoteFormContextValue = (
  formContextValue: QuoteOrDesignFormContextValue,
): formContextValue is QuoteFormContextValue => formContextValue.formType === 'Quote';

export function assertIsQuoteFormContextValue(
  formContextValue: QuoteOrDesignFormContextValue,
): asserts formContextValue is QuoteFormContextValue {
  if (!isQuoteFormContextValue(formContextValue)) {
    throw new Error(`Expected form type to be 'Quote', but was '${formContextValue.formType}'`);
  }
}
